import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon } from 'lucide-react';
const Header = () => {
  return <header className="bg-white" data-id="element-1232">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-1233"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-1234">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-1235">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-1236">
            MEDPRESS GAZETTE
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-1237">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-1238">
          <div className="text-left" data-id="element-1239">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-1240">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-1241">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-1242">
        <div className="max-w-4xl mx-auto" data-id="element-1243">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-1244">
            INVESTIGATIVE REPORT
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-5" data-id="element-1245">
            Dermatology Nurse Investigates: Do Red Light Therapy Caps Actually Work, 
            or Is It Another Wellness Scam?
          </h1>

          <div className="flex items-start mb-5 border-b border-gray-200 pb-5" data-id="element-1246">
            <div className="w-14 h-14 overflow-hidden rounded-full flex-shrink-0 mr-4 border border-gray-300" data-id="element-1247">
              <img src="https://cdn.magicpatterns.com/uploads/pgHF1VNF6Whvw8QDg83TjW/31.png" alt="Margaret Weiss" className="w-full h-full object-cover" data-id="element-1248" />
            </div>
            <div className="flex-1" data-id="element-1249">
              <div className="flex items-center" data-id="element-1250">
                <div className="font-medium text-gray-900 text-lg" data-id="element-1251">
                  By Margaret Weiss, RN, MSN
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-1252">
                  <CheckCircleIcon className="h-4 w-4" data-id="element-1253" />
                  <span className="text-xs ml-1 font-medium" data-id="element-1254">Verified</span>
                </div>
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-1255">
                Former Head of Integrative Dermatology, Cedar Sinai Medical
                Center
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-1256">
                <div className="flex items-center mr-4" data-id="element-1257">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-1258" />
                  <span data-id="element-1259">11 min read</span>
                </div>
                <div className="flex items-center" data-id="element-1260">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-1261" />
                  <span data-id="element-1262">24,867 views</span>
                </div>
              </div>
            </div>
          </div>

          <p className="font-serif text-gray-700 text-base sm:text-lg mb-6 leading-relaxed border-l-4 border-gray-300 pl-4 italic" data-id="element-1263">
            After 30 years in medicine, I've seen every "hair growth miracle" 
            come and go. So when patients started asking about red light 
            therapy caps, I decided to run a 12-month investigation. What 
            I discovered will save you thousands of dollars – and might 
            actually save your hair.
          </p>

          <div className="border-t border-gray-200 pt-3 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-1264">
            <div className="mb-1 flex items-center" data-id="element-1265">
              <span className="font-medium mr-2" data-id="element-1266">Published by:</span>
              MedPress Gazette Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-1267">
              <span className="font-medium mr-2" data-id="element-1268">Published:</span>
              {(() => {
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              return yesterday.toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric'
              });
            })()}
            </div>
          </div>
        </div>
      </div>

      {/* Author image */}
      <div className="px-4 sm:px-8 py-6 border-b border-gray-200" data-id="element-1269">
        <div className="max-w-4xl mx-auto" data-id="element-1270">
          <div className="sm:flex items-center" data-id="element-1271">
            <div className="sm:w-1/3 mb-4 sm:mb-0 sm:mr-6" data-id="element-1272">
              <img src="https://cdn.magicpatterns.com/uploads/pgHF1VNF6Whvw8QDg83TjW/31.png" alt="Margaret Weiss, RN, MSN in hospital corridor" className="w-full rounded-lg shadow-md" data-id="element-1273" />
            </div>
            <div className="sm:w-2/3" data-id="element-1274">
              <p className="text-sm text-gray-700 mb-2" data-id="element-1275">
                <span className="font-bold" data-id="element-1276">Margaret Weiss, RN, MSN</span> has
                spent three decades in clinical practice specializing in
                integrative dermatology and trichology. As the former Head of
                Integrative Dermatology at Cedar Sinai Medical Center, she has
                evaluated hundreds of hair loss treatments and devices
                throughout her career.
              </p>
              <p className="text-sm text-gray-700" data-id="element-1277">
                Her investigative work focuses on separating evidence-based
                treatments from marketing hype, helping patients make informed
                decisions based on clinical testing rather than trends.
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default Header;